<template>
    <el-tabs type="border-card" v-model="activeName">
        <el-tab-pane label="轮播图管理" name="1">
            <CarouselManage v-if="activeName === '1'"></CarouselManage>
        </el-tab-pane>
        <el-tab-pane label="产品类别管理" name="2">
            <ProductTypeManage v-if="activeName === '2'"></ProductTypeManage>
        </el-tab-pane>
        <el-tab-pane label="产品管理" name="3">
            <ProductManage v-if="activeName === '3'"></ProductManage>
        </el-tab-pane>
        <el-tab-pane label="新闻管理" name="4">
            <NewsManage v-if="activeName === '4'"></NewsManage>
        </el-tab-pane>
    </el-tabs>
</template>

<script lang="ts" setup>
import CarouselManage from '@/components/Admin/CarouselManage.vue';
import NewsManage from '@/components/Admin/NewsManage.vue';
import ProductTypeManage from '@/components/Admin/ProductTypeManage.vue';
import ProductManage from '@/components/Admin/ProductManage.vue';
import { ref } from 'vue';

const activeName = ref('1')
</script>

<style lang="css" scoped></style>